"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _react = _interopRequireDefault(require("react"));
var _Breadcrumbs = _interopRequireDefault(require("../Components/Breadcrumbs.js"));
var _Flex = _interopRequireDefault(require("../Components/Flex.js"));
var _Link = _interopRequireDefault(require("../Components/Link.js"));
var _Loader = _interopRequireDefault(require("../Components/Loader.js"));
var _String = _interopRequireDefault(require("../Components/String.js"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _BasicViewModule = _interopRequireDefault(require("./BasicView.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Basic view
 *
 * A title, content and optional loading state.
 *
 * @package HOPS
 * @subpackage Views
 * @copyright Heritage Operations Processing Limited
 */class BasicView extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      fullWidth: true,
      gap: this.props.gap,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
        className: `${_BasicViewModule.default.header} ${this.props.hideHeaderWhenPrinting ? _BasicViewModule.default.noprint : ""}`,
        gap: 0.5,
        pt: 0.5,
        children: [this.props.breadcrumbs && this.renderBreadcrumbs(), this.props.backLink && !this.props.backLinkHidden && this.renderBackLink(), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
          alignContent: "flex-end",
          className: _BasicViewModule.default.headerInner,
          gap: 0.5,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
            alignItems: !this.useVerticalActions ? "flex-end" : undefined,
            columnar: !this.useVerticalActions,
            gap: 0.5,
            justifyContent: "space-between",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
              columnar: true,
              wrap: true,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
                bold: true,
                str: this.props.title,
                variant: "h6"
              }), this.props.titleExtra]
            }), this.props.actions && this.renderActions()]
          }), this.props.headerContentAboveDivider, !this.props.noDivider && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
            className: _BasicViewModule.default.divider
          }), this.props.headerContent]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
        mt: -0.5,
        gap: this.props.gap,
        children: !this.props.loading ? this.props.children : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          size: 35
        })
      })]
    });
  }

  /**
   * Render actions.
   * 
   * @return {ReactNode}
   */
  renderActions() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      alignItems: this.props.actionsAlign || "center",
      columnar: true,
      gap: this.props.actionsGap || 0.5,
      children: this.props.actions
    });
  }

  /**
   * Render the top back link.
   * 
   * @return {ReactNode}
   */
  renderBackLink() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      disabled: this.props.backLinkDisabled,
      label: this.props.backLinkLabel || "Back",
      startArrow: true,
      uri: this.props.backLink
    });
  }

  /**
   * Render breadcrumbs.
   * 
   * @return {ReactNode}
   */
  renderBreadcrumbs() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Breadcrumbs.default, {
      items: this.props.breadcrumbs
    });
  }

  /**
   * Get whether to use vertical actions.
   * 
   * @return {Boolean}
   */
  get useVerticalActions() {
    return this.props.isMobile && this.props.actions && !this.props.forceHorizontalActions;
  }
}
var _default = exports.default = (0, _withMobile.default)(BasicView);